module.exports = __webpack_public_path__ + "static/img/gpt41.6eeb1f6e.png";